// @ts-nocheck
// TODO: tighten types after migration
import { useState } from 'react';

const STORAGE_KEY = 'adminNavPinned';

export function useNavPinned() {
    const [navPinned, setNavPinnedState] = useState(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored === null ? true : stored === 'true';
    });

    const setNavPinned = (value) => {
        const newVal = typeof value === 'function' ? value(navPinned) : value;
        setNavPinnedState(newVal);
        localStorage.setItem(STORAGE_KEY, String(newVal));
    };

    return [navPinned, setNavPinned];
}
